import Phaser from "phaser";
import { GAME_HEIGHT, GAME_WIDTH } from "../../config";

export interface Star {
  obj: Phaser.GameObjects.Arc;
  speed: number;
}

export class Starfield {
  private stars: Star[] = [];
  private scene: Phaser.Scene;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  create(count = 100): void {
    this.stars = [];
    for (let i = 0; i < count; i++) {
      const star = this.scene.add.circle(
        Phaser.Math.Between(0, GAME_WIDTH),
        Phaser.Math.Between(0, GAME_HEIGHT),
        Phaser.Math.Between(1, 2),
        0xffffff,
        Phaser.Math.FloatBetween(0.3, 1),
      );
      this.stars.push({
        obj: star,
        speed: Phaser.Math.FloatBetween(0.1, 0.5),
      });
    }
  }

  update(shipVelocity: Phaser.Math.Vector2): void {
    for (const star of this.stars) {
      star.obj.x -= shipVelocity.x * star.speed * 0.01;
      star.obj.y -= shipVelocity.y * star.speed * 0.01;

      // Wrap stars
      if (star.obj.x < 0) star.obj.x = GAME_WIDTH;
      if (star.obj.x > GAME_WIDTH) star.obj.x = 0;
      if (star.obj.y < 0) star.obj.y = GAME_HEIGHT;
      if (star.obj.y > GAME_HEIGHT) star.obj.y = 0;
    }
  }
}
